import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.openRequestedPanel = () => this.openManagement()
    this.element.addEventListener('consultations:open-management', this.openRequestedPanel)
    this.pendingRequest = null
    this.requestStarted = event => {
      if (!this.isManagementRequest(event.target)) return
      const xhr = event.detail[0]
      this.pendingRequest = xhr
      this.openManagement()
      this.setStatus('Chargement…', true)
      // The response may replace the link/form itself, so listen on the XHR.
      xhr.addEventListener('loadend', () => {
        if (this.pendingRequest !== xhr) return
        this.pendingRequest = null
        const succeeded = xhr.status >= 200 && xhr.status < 300
        this.setStatus(succeeded ? '' : 'Le contenu n’a pas pu être chargé. Veuillez réessayer.', false)
      }, { once: true })
    }
    this.element.addEventListener('ajax:beforeSend', this.requestStarted)
  }

  disconnect() {
    this.element.removeEventListener('consultations:open-management', this.openRequestedPanel)
    this.element.removeEventListener('ajax:beforeSend', this.requestStarted)
  }

  navigate(event) {
    const home = event.target.closest('[data-dashboard-home]')
    const tabButton = event.target.closest('[data-dashboard-tab], .nav-tabs [role="tab"]')
    if (home || tabButton) {
      event.preventDefault()
      event.stopPropagation()
      const tab = home ? 'agenda' : (tabButton.dataset.dashboardTab || tabButton.hash.slice(1))
      if (tab === 'agenda') this.element.classList.remove('is-managing')
      this.activateTab(tab)
      this.scrollToWorkspace()
      return
    }
    if (this.isManagementRequest(event.target.closest('a, form'))) this.openManagement()
  }

  isManagementRequest(target) {
    if (!target || !this.element.querySelector('.consultations-management')) return false
    if (target.matches('[data-dashboard-history]')) return false
    if (target.matches('[data-dashboard-management]')) return true
    if (target.closest('.consultations-management') && target.matches('a[data-remote], form[data-remote]')) return true
    // Rendez-vous ouverts depuis l’historique d’un patient.
    return target.matches('a[data-remote]') && /\/meetings\/\d+(?:\?|$)/.test(target.getAttribute('href') || '')
  }

  activateTab(id) {
    const link = this.element.querySelector(`.nav-tabs a[href="#${id}"]`)
    if (!link) return
    this.element.querySelectorAll('.nav-tabs [role="tab"]').forEach(tab => {
      const active = tab === link
      tab.classList.toggle('active', active)
      tab.setAttribute('aria-selected', String(active))
    })
    this.element.querySelectorAll('.consultations-tab-content > .tab-pane').forEach(pane => {
      const active = pane.id === id
      pane.classList.toggle('active', active)
      pane.classList.toggle('show', active)
    })
  }

  openManagement() {
    if (!this.element.querySelector('.consultations-management')) return
    this.element.classList.add('is-managing')
    this.activateTab('agenda')
    this.scrollToWorkspace()
  }

  scrollToWorkspace() {
    const workspace = this.element.querySelector('.tab-content')
    if (workspace) workspace.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  setStatus(message, busy) {
    const status = this.element.querySelector('.consultations-workspace-status')
    const content = this.element.querySelector('.consultations-management .index-meetings')
    if (status) {
      status.textContent = message
      status.hidden = !message
    }
    if (content) content.setAttribute('aria-busy', String(busy))
  }
}
